import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  
  if (typeof window !== 'undefined' && window.localStorage) {
    const token = localStorage.getItem('authToken');
    if (token) {
      // Basic check, actual validation happens on the backend
      return true;
    }
  }

  // Not authenticated, redirect to login
  router.navigate(['/auth/login']);
  return false;
};
